"use strict";

PF.DynamicPage = class DynamicPage extends PF.Widget
	{

	static get options()
		{
		return {
			dom: {
				content: undefined,
			},
			html: PF.DynamicPage.templates,
			title: "",
			f7config: {},
			routeConfig: {},
			path: 'dynamic-' + PF.H.randomString(5),
		};
		}

	static get template()
		{
		// language=HTML
		return {
			page: `
				<div class="page">
					<div class="navbar" pf="navBar">
						<div class="navbar-bg"></div>
						<div class="navbar-inner" pf="navbarInner">
							<div class="left">
								<a href="#" class="link back" pf="close">
									<i class="icon icon-back"></i>
								</a>
							</div>
							<div class="center" pf="pageTitle"></div>
						</div>
					</div>
					<div class="page-content" pf="pageContent">
						<div class="stretch-block" pf="stretchBlock">

						</div>
					</div>
				</div>
			`
		};
		}

	init()
		{
		this.opened = false;
		this.dom.loads(this.html);
		if (this.html.content !== undefined)
			{
			this.dom.load(this.html.content, 'content');
			}
		this.dom.stretchBlock.append(this.dom.content);

		this.fullPath = app.router.currentRoute.path + '/' + this.path;
		this.route = {
			path: this.fullPath,
			component: {
				render: () => this.dom.page,
			},
			// history: false
			// beforeLeave: (routeTo, routeFrom, resolve, reject) => {
			// 	// this.f7popup.close();
			// 	resolve();
			// }
		};

		app.mainView.routes.push(this.route);

		// this.dom.close.on('click', () => this.f7popup.close());
		this.bindNode('title', this.dom.pageTitle, MK.binders.text());
		}

	open()
		{
		app.router.navigate(this.fullPath);
		this.opened = true;
		}

	close()
		{
		// if (this.f7popup !== undefined)
		// 	{
		// 	this.f7popup.close();
		// 	}
		app.router.back();
		}
	};